import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_core/global.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { ThemeService } from 'src/app/_core/_services/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input('headerTitle') public title_: string = null;
  @Input('navBack') public navBack_: string;
  @Input('navClose') public close_: boolean = false;
  @Input('accessActions') public accessActions_: boolean = true;
  @Input('showCredit') public showCredit_: boolean = true;

  public User$: any = {};
  public UserCredits$: number;
  public LightTheme$: boolean;
  public UserSubscribed$: boolean;

  public winWidth: number = window.innerWidth;

  constructor(
    public beh: BehaviorService,
    public _location: Location,
    private router: Router,
    private themeSvc: ThemeService,
    private event: EventsService,
    public global: GlobalService
  ) {
    this.themeSvc.lightTheme.subscribe(l => { this.LightTheme$ = l });
    this.beh.UserAccount.subscribe(u => { this.User$ = u });
    this.beh.UserWallet.subscribe(w => { this.UserCredits$ = w.total || 0 });
    this.beh.UserSubscription.subscribe(userSub => { this.UserSubscribed$ = !!userSub?.subscriptions?.length });

    window.addEventListener('resize', () => { this.winWidth = window.innerWidth });
  }

  ngOnInit(): void { }

  public navigateTo(path: string[]) {
    this.router.navigate(path);
  }

  public resgistEvent(et) {
    this.event.eventStart({ eventType: et, eventCategory: 'CLICK' });
  }

}